import {HttpClient} from "@angular/common/http";
import {Component, Input, OnInit, ViewChild} from "@angular/core";
import * as Dropzone from "dropzone";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";
import {DROPZONE_CONFIG} from "ngx-dropzone-wrapper";
import {DmsAccessService} from "../services/dms-access.service";
import {DownloadService} from "../services/download.service";
import {HelperService} from "../services/helper.service";
import {TosterMessageService} from "../services/toster-message.service";
import { API_URL } from '../config'
@Component({
  selector: "common-attachment",
  templateUrl: "./common-attachment.component.html",
  styleUrls: ["./common-attachment.component.scss"],
  providers: [
    TosterMessageService,
    HelperService,
    DmsAccessService,
    DownloadService,
  ],
})
export class CommonAttachmentComponent implements OnInit {
  public dbData = [];
  public dbDataAction = [];
  toolTipHtml: string;
  @Input("documentSystemCode") public documentSystemCode: any;
  @Input("documentSystemID") public documentSystemID: any;
  @Input("trainingRecordID") public trainingRecordID: any;
  @Input("confirmedYN") public confirmedYN: any;
  @ViewChild(DropzoneComponent) public componentRef?: DropzoneComponent;
  @ViewChild("swalModalDelete") public swalModalDelete: any;
  public selectedItem: any;
  public disabled: boolean = false;

  constructor(
    http: HttpClient,
    private helperService: HelperService,
    private downloadService: DownloadService,
    private modalService: BsModalService,
    private tosterMessageService: TosterMessageService,
    private dmsAccessService: DmsAccessService
  ) {
    Dropzone.autoDiscover = false;
  }

  public ngOnInit() {
    this.modalService.onHide.subscribe((reason: string, event) => {
      if (reason) {
        if (reason === 'corrective_action_closed') {
          this.getalldbmsfiles();
        }
        if (reason === 'corrective_action_success') {
          this.getalldbmsfiles();
        }
        if (reason === 'corrective_action_edit_closed') {
          this.getalldbmsfiles();
        }
      }
    });
    setTimeout(() => {
      this.getalldbmsfiles();

      if (this.confirmedYN == 1 || this.confirmedYN == -1) {
        this.disabled = !this.disabled;
      }
    }, 0);
  }

  public config: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    // url: API_URL+"/api/v1/uploaddmsfiles",
    url: API_URL+"/api/v1/uploaddmsfilesTraining",


    /*  addRemoveLinks: true,
      previewsContainer: '.dropzone-previews',*/
    clickable: true,
    maxFiles: 10,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
    headers: this.downloadService.createAuthHeaderFileUpload(),
  };


  getdata(value: string,id:any): void {
    
    console.log(value); // You can do something with the value here
  }







  public getalldbmsfiles() {
    const that = this;
    const item: any = [];
    item.companySystemID = that.helperService.getSelectedCompanyId();
    item.documentSystemCode = that.documentSystemCode;
    item.documentSystemID = that.documentSystemID;
    item.trainingRecordID = that.trainingRecordID;

    console.log(item.companySystemID);
    console.log(item.documentSystemCode);
    console.log(item.documentSystemID);
    console.log(item.trainingRecordID);

    let requestObservable;
    if (item.trainingRecordID) { 
      requestObservable = that.dmsAccessService.getAllcommonFilesWebTraining();
    } else {
      requestObservable = that.dmsAccessService.getAllcommonFilesWeb();
    }

    // that.dmsAccessService
      // .getAllcommonFilesWeb()
      // .getAllcommonFilesWebTraining()
      requestObservable
      .get(item)
      .subscribe(
        (resp) => {
          that.dbData = resp.data.data.master;
          that.dbDataAction = resp.data.data.action;
        },
        (error) => {
          // this.tosterMessageService.showError(
          //   "Error",
          //   "Unable to retreived the data"
          // );
        }
      );
  }

  public onSending(data): void {
    // data [ File , xhr, formData]
    const file = data[0];
    const formData = data[2];
    formData.append("id", this.helperService.getuserID());
    formData.append("documentSystemID", this.documentSystemID);
    formData.append("masterID", this.documentSystemCode);
    formData.append("trainingRecordID", this.trainingRecordID);
    formData.append("companySystemID", this.helperService.getSelectedCompanyId());
    
  }

  public deletecommonFile(attachmentID) {
    this.selectedItem = attachmentID;
    this.swalModalDelete.show();
  }

  public queuecomplete() {
    this.getalldbmsfiles();
    setTimeout(() => {
      this.componentRef.directiveRef.reset();
    }, 2000);
  }

  public dmsFile(item) {
    //this.dmsAccessService.downloadDocument2(item.attachmentID, item.pathFileName);
    this.dmsAccessService.downloadDocument2(
      item.attachmentID,
      item.fileNameWithExtenstion
    );
  }

  public removeItem() {
    const that = this;
    /*  that.spinner.show();*/
    this.dmsAccessService
      .deleteCommonFiles()
      .get({id: this.selectedItem})
      .subscribe(
        (resp) => {
          this.tosterMessageService.showSuccess(
            "Success",
            "Successfully deleted"
          );
          /*that.spinner.hide();*/
          this.getalldbmsfiles();
        },
        (error) => {
          this.tosterMessageService.showError("Error", "Unable to delete");
        }
      );
  }






  updateRecord(autoId: number, event: any) {
    const isChecked = event.target.checked;
    const isApply = isChecked ? 1 : 0;
    const requestData = {
      auto_id: autoId,
      isApply: isApply,
    };
    console.log(requestData);
    console.log(this.documentSystemCode);
    this.dmsAccessService
    .updateAttathmentStatus(this.documentSystemCode)
    .customPUT(requestData)
    .subscribe(
      (resp: any) => {
        console.log(resp);
        if(isChecked === true) {
          let message = "Attathments will be displayed in the report";
          this.tosterMessageService.showSuccess("Success!", message);
        } else {
          let message = "Attathments will not displayed in the report";
          this.tosterMessageService.showSuccess("Success!", message);
        }
      },
      (error) => { 
      }
    );
}




}



// WEBPACK FOOTER //
// /app/src/app/common-attachment/common-attachment.component.ts